/** @jsxImportSource @emotion/react */
import { ChangeEvent, useState, useEffect} from "react";
import { Control, UseFormRegister, UseFormSetValue, UseFormGetValues } from "react-hook-form";
import { ResponseParamBase, ChatType } from "../../common/Types";
import { ColorChangeHandler, ColorResult, SketchPicker, Color } from 'react-color';
import { IFormInputs } from "../Config";
import configcss from "../../css/config.module.css";
import basecss from "../../css/base.module.css";

type ResponseParam = ResponseParamBase & {
}

type ChatData = {
    message: string,
    updateTime: Date,
    type: ChatType,
}

/*export interface IFormInputs {
    color: string,
}*/

export const ColorType = {
    backgroundColor: "backgroundColor",
    headerTextColor: "headerTextColor",
    adminbubblebackgroundcolor: "adminBubbleBackgroundColor",
    adminbubbletextcolor: "adminBubbleTextColor",
    guestbubblebackgroundcolor: "guestBubbleBackgroundColor",
    guestbubbletextcolor: "guestBubbleTextColor",
    footerbackgroundcolor: "footerBackgroundColor",
    footertextcolor: "footerTextColor",
    footertextareacolor: "footerTextareaColor",
    footertextareaplaceholdercolor: "footerTextareaPlaceholderColor",
    sendbuttoncolor: "sendButtonColor",
    headercolor: "headerColor",
} as const
export type ColorType = typeof ColorType[keyof typeof ColorType]

export type ColorComponentParam = {
    colorType: ColorType,
    selectedColor: string,
    colorList: string[],
    onChangeColor: (color: string, type: ColorType) => void,
    control: Control<IFormInputs>,
    register: UseFormRegister<IFormInputs>,
    setValue: UseFormSetValue<IFormInputs>,
    getvalue: UseFormGetValues<IFormInputs>,
}

export const ColorPicker = (prop: ColorComponentParam) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [backgroundColor, setBackgroundColor] = useState<Color>(prop.selectedColor)

    /*const schema = Yup.object({
        question: requireValidateion,
    }).required();

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            color: prop.selectedColor,            
        },
        //resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        UploadFile<ResponseParam>(ApiUrl.UpdateUserColor, {'color': backgroundColor, 'type': prop.colorType}, setIsLoading)
        .then((response) => {
            prop.onChangeColor(backgroundColor.toString(), prop.colorType);
        });
    }*/

    const handleBackgroundColor: ColorChangeHandler = async (color: ColorResult, event: ChangeEvent) => {        
        
        setBackgroundColor((value) => {return color.hex});
        prop.onChangeColor(color.hex, prop.colorType);
        prop.setValue(prop.colorType, color.hex)
    }

    const saveColor = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        
    }

    useEffect(() => {
        (async() => {
        })()
    }, [])

    function colorHeader(type: ColorType): string {
        switch (type) {
            case ColorType.backgroundColor:
                return "背景色";
            case ColorType.adminbubblebackgroundcolor:
                return "ボットの吹き出し背景色";
            case ColorType.adminbubbletextcolor:
                return "ボットの吹き出し文字色";
            case ColorType.guestbubblebackgroundcolor:
                return "利用者の吹き出し背景色";
            case ColorType.guestbubbletextcolor:
                return "利用者の吹き出し文字色";
            case ColorType.footerbackgroundcolor:
                return "質問入力の背景色";
            case ColorType.footertextcolor:
                return "質問入力の文字色";
            case ColorType.sendbuttoncolor:
                return "送信ボタンの色";
            default:
                return "背景色";
        }

    }

    return (
        <>
        <div className={configcss['infoBox']}>
            <div className={`${configcss['infoBoxInner']} ${configcss['mdlBox']}`}>
                <div className={`${configcss['infoBoxInner-sub']} ${configcss['layoutBox']}`}>
                    <div className={basecss['circularprogress']}>
                        <SketchPicker color={prop.getvalue(prop.colorType)} onChange={handleBackgroundColor} disableAlpha={true}></SketchPicker>
                    </div>
                </div>
            </div>
            <input type="hidden" value={prop.selectedColor} {...prop.register(prop.colorType)}></input>
        </div>
        </>
    )
}